import { render, staticRenderFns } from "./formWrap.vue?vue&type=template&id=0cf4a318&scoped=true"
import script from "./formWrap.vue?vue&type=script&lang=js"
export * from "./formWrap.vue?vue&type=script&lang=js"
import style0 from "./formWrap.vue?vue&type=style&index=0&id=0cf4a318&prod&lang=less&scoped=true"
import style1 from "./formWrap.vue?vue&type=style&index=1&id=0cf4a318&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4a318",
  null
  
)

export default component.exports